module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('a', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript://"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('i', {
    staticClass: "icon-bell fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "visible-xs-inline"
  }, [_vm._v("Notificações")]), _vm._v(" "), _c('span', {
    staticClass: "badge badge-sm up bg-danger pull-right-xs"
  }, [_vm._v("1")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-menu w-xl"
  }, [_c('div', {
    staticClass: "panel bg-white animated fadeInRight"
  }, [_c('div', {
    staticClass: "panel-heading b-light bg-light"
  }, [_c('strong', [_vm._v("Você tem "), _c('span', [_vm._v("1")]), _vm._v(" notificação")])]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "javascript://"
    }
  }, [_c('span', {
    staticClass: "label bg-light"
  }, [_vm._v("Dev Team")]), _vm._v(" "), _c('span', {
    staticClass: "clear block m-b-none"
  }, [_vm._v("\n                      Pessoal, o sistema de notificação está desativado temporariamente"), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("1 hora atrás")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer text-sm"
  }, [_c('a', {
    staticClass: "pull-right",
    attrs: {
      "href": "javascript://"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript://",
      "data-toggle": "class:show animated fadeInRight"
    }
  }, [_vm._v("Ver todas as notificações")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8415d74e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/header/Notification.vue
// module id = 1988
// module chunks = 18